import React from 'react';
import Header from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import PageHero from './Component/PageHero';
import home4 from './Component/home4.png';
import in1 from './Component/in1.png';
import in2 from './Component/in2.png';
import in3 from './Component/in3.png';
import in4 from './Component/in4.png';

const galleries = [
  { href: '/products/carpet', image: in1, label: 'Carpet Gallery' },
  { href: '/products/hardwood', image: in2, label: 'Hardwood Gallery' },
  { href: '/products/Tile', image: in3, label: 'Tile Gallery' },
  { href: '/products/luxuryvinyl', image: in4, label: 'Luxury Vinyl Gallery' },
];

function Inspiration() {
  return (
    <div className="min-h-screen bg-[#f7f8fa] text-slate-900 antialiased">
      <Header />
      <PageHero
        eyebrow="Ideas & galleries"
        title="Reimagine your space"
        subtitle="Get inspired with our beautiful flooring galleries"
      />

      <section className="pb-8 md:pb-12">
        <div className="mx-auto grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8">
          {galleries.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="group overflow-hidden rounded-[1.5rem] bg-white no-underline shadow-sm ring-1 ring-slate-200/80 transition hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.label}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
              </div>
              <div className="px-4 py-3 text-center">
                <span className="text-sm font-semibold text-[#0075ca] sm:text-base">
                  {item.label}
                </span>
              </div>
            </a>
          ))}
        </div>
      </section>

      <Request />

      <section className="border-t border-slate-200 py-12 md:py-16">
        <div className="mx-auto max-w-6xl px-4 text-center sm:px-6 lg:px-8">
          <h2 className="text-xl font-semibold tracking-tight sm:text-2xl md:text-3xl">
            Featured brands &amp; technologies
          </h2>
          <img src={home4} alt="Featured brands" className="mx-auto mt-8 max-w-full" />
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Inspiration;
